import { css, Theme } from '@mui/material'

export const riskSearchContainer = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const riskButtonWrapper = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  padding: 0px 64px;
  margin-top: 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  ${theme.breakpoints.down('md')} {
    padding: 0px 32px;
  }

  ${theme.breakpoints.down('sm')} {
    padding: 0px 16px;
    gap: 12px;
  }
`
export const riskSearchTitle = css`
  color: #0b2948;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`
